import type { Node } from 'react'
import React from 'react'
import styled from 'styled-components'
import type { HeaderBackground } from 'app/common/header'
import { Header } from 'app/ecommerce/common'
import { CookiesConsent } from 'app/common/cookies/consent'
import { featureCodes } from 'shared/utils'
import { FeatureToggle } from 'app/common/feature-toggle'

type Props = {
    headerShouldStick?: boolean,
    border?: boolean,
    color?: string,
    background?: HeaderBackground,
    children?: Node,
    withQuickSearch?: boolean,
    showAppBanner?: boolean,
    cart?: boolean,
    currentStep?: number,
    showLogoBK?: boolean,
    backUrl?: string,
    backEnabled?: boolean,
    backgroundColor?: string,
    noDelivery?: boolean,
    onCloseUrl?: String,
    noFooter?: boolean,
    onClose?: () => void
}

export const Layout = (props: Props) => {
    const { children, backgroundColor, noFooter, ...otherProps } = props
    const { currentStep } = otherProps
    return (
        <Main backgroundColor={backgroundColor} noFooter={noFooter}>
            {currentStep === 4 ? null : <Header {...otherProps} />}
            {children}
            {process.env.REACT_APP_ENABLE_ONETRUST !== 'true' && (
                <FeatureToggle features={[featureCodes.ENABLE_COOKIES_CONSENT]}>
                    <CookiesConsent />
                </FeatureToggle>
            )}
        </Main>
    )
}

const Main = styled.main`
    position: relative;
    overflow-x: hidden;
    min-height: ${props => (props.noFooter ? '100vh' : 'calc(100vh - 40px)')};
    ${props =>
        props.backgroundColor && `background-color: ${props.backgroundColor};`};
`
